export const getMessage: any = {
  DUPLICATE_USERNAME_EXCEPTION: 'User details already exists. Please use different details.',
  CANCELLATION_SUCCESS: 'Your request has been recorded successfully',
  PARTNER_SUCCESSFUL: 'Your record added successfully',
  UPDATEACCOUNT_SUCCESS: 'Your record updated successfully',
  TECHNICAL_ERROR: 'There is some technical error. Please try after some time.',
  CHECK_IN_SUCCESS: 'You checked in successfully!!!',
  CHECK_OUT_SUCCESS: 'You checked out successfully!!!',
  SERVICEPROVIDER_FEEDBACK_SUCCESS: 'Your review added successfully',
  NOT_GOT_BILLING_RATE: 'There is an error in billing, please try again after some time.',
  PARKING_ADDED_TO_FAVOURITE: 'Parking successfully added to favourite',
  ERROR_ON_ADDING_PARKING_TO_FAVOURITE: 'There is some technical error. Please try again after some time.',
  INVALID_CREDENTIALS: 'Entered username or password are invalid. Please enter correct credentials.',
  USER_ALREADY_EXIST: 'User already exists with provided email id. Please login or do forgot password.',
  SERVICE_EXCEPTION: 'Unable to process your request. Please contact service desk.',
  BOOKING_CREATION_FAIL:
    'There is some technical issue. Your booking failed and refund initiated. Please check your email.',
  ERROR_FORGOT_PASSWORD: 'Invalid email Id. Please enter correct details.',
  SUCCESS_FORGOT_PASSWORD: 'New password sent successfully to registered email id',
  ERROR_LOGIN: 'Invalid email or password',
  ERROR_LOGIN_UTCUST: 'You are not authorized to use this application',
  PARKING_SPACE_LOCATION_NOT_FOUND_EXCEPTION_MSG: 'Parking space location not found. Please contact service desk.',
  PARKING_SPACE_LOCATION_EXIST_EXCEPTION_MSG: 'Parking space location already exists. Please contact service desk.',
  SUCCESS_LINK: 'Link sent successfully',
  ERROR_LINK: 'Invalid email Id. Please enter correct details.',
};
